import { Timer } from "@/components/Timer";
import { Config } from "@/components/Config";
import { useState } from "react";
import "./index.css";

export function App() {
  const [showConfig, setShowConfig] = useState(false);
  const [configKey, setConfigKey] = useState(0);

  function handleConfigSave() {
    setConfigKey((prev) => prev + 1);
  }

  return (
    <main className="px-6">
      <Timer key={configKey} onShowConfig={() => setShowConfig(true)} />
      {showConfig && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm animate-fade-in"
          onClick={() => setShowConfig(false)}
        >
          <div className="animate-scale-in" onClick={(e) => e.stopPropagation()}>
            <Config onClose={() => setShowConfig(false)} onSave={handleConfigSave} />
          </div>
        </div>
      )}
    </main>
  );
}

export default App;
